export class ResetState {
    public static readonly type = '[JobsPlacements] Reset state';
}
